import { Amplify } from 'aws-amplify';

export const configureAmplify = () => {
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: process.env
                    .REACT_APP_AWS_COGNITO_USER_POOL_ID as string,
                userPoolClientId: process.env
                    .REACT_APP_AWS_COGNITO_USER_POOL_WEB_CLIENT_ID as string,
                loginWith: {
                    oauth: {
                        domain: process.env
                            .REACT_APP_AWS_COGNITO_IDP_DOMAIN as string,
                        scopes: ['email', 'openid'],
                        redirectSignIn: [
                            process.env
                                .REACT_APP_AWS_COGNITO_REDIRECT_SIGN_IN as string,
                        ],
                        redirectSignOut: [
                            process.env
                                .REACT_APP_AWS_COGNITO_REDIRECT_SIGN_IN as string,
                        ],
                        responseType: 'code',
                    },
                },
            },
        },
    });
};
